import React, { createContext, useContext, useRef, useState } from 'react';

const LogoLayoutContext = createContext(null);

export const LogoLayoutProvider = ({ children }) => {
  // Stack of active slot entries: { node, pathname }. Last entry that matches
  // the current pathname wins.
  const slotsRef = useRef([]);
  const [version, setVersion] = useState(0);

  const registerSlot = (node, pathname) => {
    slotsRef.current = [...slotsRef.current, { node, pathname }];
    setVersion((v) => v + 1);
  };

  const unregisterSlot = (node) => {
    slotsRef.current = slotsRef.current.filter((entry) => entry.node !== node);
    setVersion((v) => v + 1);
  };

  // Returns the most recent slot for the given pathname, or null. If no
  // pathname is supplied, returns the latest slot regardless.
  const getActiveSlot = (pathname) => {
    const list = slotsRef.current;
    if (pathname == null) return list[list.length - 1]?.node || null;
    for (let i = list.length - 1; i >= 0; i -= 1) {
      if (list[i].pathname === pathname) return list[i].node;
    }
    return null;
  };

  return (
    <LogoLayoutContext.Provider value={{ registerSlot, unregisterSlot, getActiveSlot, version }}>
      {children}
    </LogoLayoutContext.Provider>
  );
};

export const useLogoLayout = () => {
  const ctx = useContext(LogoLayoutContext);
  if (!ctx) {
    return {
      registerSlot: () => {},
      unregisterSlot: () => {},
      getActiveSlot: () => null,
      version: 0,
    };
  }
  return ctx;
};
